import { Box, Flex, Text, useToken } from '@chakra-ui/react';
import { ReactElement } from 'react';
import './MetricCard.css';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: ReactElement;
  /** A RESOLVED colour (e.g. from `useToken`), not a token name: it is applied
   *  through `style`, which Chakra does not translate. Defaults to `chart.1`. */
  iconColor?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  isLoading?: boolean;
}

const MetricCard = ({ 
  title, 
  value, 
  icon, 
  iconColor,
  trend,
  isLoading = false 
}: MetricCardProps) => {
  const [defaultIconColor] = useToken('colors', ['chart.1']);
  return (
    <Box className="metric-card">
      <Flex justify="space-between" align="flex-start" mb={4}>
        <Box>
          <Text className="metric-card-title">{title}</Text>
          {isLoading ? (
            <Box className="metric-card-skeleton" />
          ) : (
            <Text className="metric-card-value">{value}</Text>
          )}
          {trend && !isLoading && (
            <Flex align="center" mt={2}>
              <Text
                className="metric-card-trend"
                color={trend.isPositive ? 'status.success' : 'status.error'}
              >
                {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
              </Text>
            </Flex>
          )}
        </Box>
        {/* The icon is drawn in currentColor, so it takes chart.fg from this
            Box. `<Icon as={() => icon}>` never forwarded colour or size. */}
        <Box
          className="metric-card-icon"
          data-testid="metric-card-icon"
          color="chart.fg"
          fontSize="24px"
          style={{ backgroundColor: iconColor ?? defaultIconColor }}
        >
          {icon}
        </Box>
      </Flex>
    </Box>
  );
};

export default MetricCard;

